export const HIGHDEMAND_PATH = {
  PROFILE_BACKGROUND:
    '/api/rs-aliados-gateway/orders/partner/status/:partnerId/profile-background',
} as const;
